import React from 'react';
import { Button, Grid } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { PaddedContainer } from '../../ui-kit';
import { LocationReferrer } from '../../types/locationReferrer';

const StatisticsContainer: React.FC = ({ children }) => {
    const { t } = useTranslation();
    const history = useHistory<LocationReferrer>();
    const { state = {} } = history.location;
    const { referrer } = state;
    return (
        <PaddedContainer spacing={6}>
            {referrer
                ? (
                    <Grid item xs={12}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            component={RouterLink}
                            to={referrer}
                            variant="contained"
                            color="primary"
                        >
                            {t('Back')}
                        </Button>
                    </Grid>
                ): null}
            <Grid item xs={12}>
                {children}
            </Grid>
        </PaddedContainer>
    );
};

export default StatisticsContainer;
